import Loadable from 'react-loadable';

import { LoadingPageLoadable } from 'modules/main/pages/Loading';

export const NotificationsLinksLoadable = Loadable({
  loader: () =>
    import(
      /* webpackChunkName: "NotificationsLinks" */
      './NotificationsLinks.dynamic'
    ),
  loading: LoadingPageLoadable,
});
